module.exports = __webpack_public_path__ + "09_mole.566e9ce6.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer2/09_mole.png
// module id = urGi
// module chunks = 0